import { Card, Col, PageHeader, Row, Space, Tag } from "antd";
import { FaAddressCard, FaUserAlt, FaCity } from "react-icons/fa";
import { BsFillTelephoneFill } from "react-icons/bs";
import { CgWebsite } from "react-icons/cg";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { getCompanyDetail } from "api/company";
import { useEffect } from "react";
import { useParams } from "react-router-dom";

const CompanyDetail = () => {
  const { id } = useParams();
  const { t } = useTranslation("translation");
  const { data, mutate } = useMutation("get-companyDetail", getCompanyDetail);
  useEffect(() => {
    mutate(id as string);
    // eslint-disable-next-line
  }, [id]);
  return (
    <div>
      <PageHeader
        title={`${t("company_detail")}: ${data?.companyName}`}
        onBack={() => window.history.back()}
        className="site-page-header-responsive"
        style={{ padding: 0 }}>
        <Card>
          <Row>
            <Col md={24} style={{ minHeight: 100 }}>
              <Card style={{ height: "100%" }}>
                <Row className="mt-2">
                  <Col style={{ paddingRight: 20, marginTop: 15 }} span={12}>
                    <Row>
                      <Space>
                        <div style={{ marginTop: 5 }}>
                          <FaUserAlt size="28" />
                        </div>
                        <h2>{t("Company_name")}</h2>
                      </Space>
                    </Row>
                    {data?.companyName || "-"}
                  </Col>
                  <Col style={{ paddingRight: 2, marginTop: 20 }} span={12}>
                    <Row>
                      <Space>
                        <div style={{ marginTop: 5 }}>
                          <BsFillTelephoneFill size="28" />
                        </div>
                        <h3>{t("Phone_phone")}</h3>
                      </Space>
                    </Row>
                    {data?.phone || "-"}
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col style={{ paddingRight: 20, marginTop: 15 }} span={12}>
                    <Row>
                      <Space>
                        <div style={{ marginTop: 5 }}>
                          <FaAddressCard size="28" />
                        </div>
                        <h2>{t("Country")}</h2>
                      </Space>
                    </Row>
                    {data?.country || "-"}
                  </Col>
                  <Col style={{ paddingRight: 2, marginTop: 20 }} span={12}>
                    <Row>
                      <Space>
                        <div style={{ marginTop: 5 }}>
                          <FaAddressCard size="28" />
                        </div>
                        <h3>{t("state_or_Province")}</h3>
                      </Space>
                    </Row>
                    {data?.state || "-"}
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col style={{ paddingRight: 20, marginTop: 15 }} span={12}>
                    <Row>
                      <Space>
                        <div style={{ marginTop: 5 }}>
                          <FaCity size="28" />
                        </div>
                        <h2>{t("City_city")}</h2>
                      </Space>
                    </Row>
                    {data?.city || "-"}
                  </Col>
                  <Col style={{ paddingRight: 2, marginTop: 20 }} span={12}>
                    <Row className="mr-2">
                      <Space>
                        <div style={{ marginTop: 5 }}>
                          <FaAddressCard size="28" />
                        </div>
                        <h3>{t("Other_address")}</h3>
                      </Space>
                    </Row>
                    {data?.otherAddress || "-"}
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col style={{ paddingRight: 20, marginTop: 15 }} span={12}>
                    <Row>
                      <Space>
                        <div style={{ marginTop: 5 }}>
                          <FaAddressCard size="28" />
                        </div>
                        <h2>{t("House_number")}</h2>
                      </Space>
                    </Row>
                    {data?.houseNumber || "-"}
                  </Col>
                  <Col style={{ paddingRight: 20, marginTop: 15 }} span={12}>
                    <Row>
                      <Space>
                        <div style={{ marginTop: 5 }}>
                          <CgWebsite size="28" />
                        </div>
                        <h2>{t("Company_website")}</h2>
                      </Space>
                    </Row>
                    {data?.website || "-"}
                  </Col>
                  <Col style={{ paddingRight: 20, marginTop: 15 }} span={12}>
                    <Row>
                      <Space>
                        <div style={{ marginTop: 5 }}>
                          <FaAddressCard size="28" />
                        </div>
                        <h2>{t("Industry_type")}</h2>
                      </Space>
                    </Row>
                    {
                      <>
                        {data?.companyTags.map((item, index) => (
                          <Tag key={index}>{item?.name}</Tag>
                        ))}
                      </>
                    }
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </Card>
      </PageHeader>
    </div>
  );
};

export default CompanyDetail;
